import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { formatISO } from 'date-fns';
import { OpenIdCallback } from 'helpers/auth/openid/OpenIdCallback';
import { postServerLogOut, setAuthData } from 'helpers/auth/auth-interceptor';
import { backendUri } from 'helpers/auth/openid/openid-settings';
import { Loading } from './components/uikit/suspense/Loading';
import { LoginErrorPage } from 'pages/unauthorized/LoginErrorPage';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'services/api/query-client-helper';
import { UseCookieAuth } from 'helpers/auth/auth-settings';
import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import de from 'i18n-iso-countries/langs/de.json';
import es from 'i18n-iso-countries/langs/es.json';
import fr from 'i18n-iso-countries/langs/fr.json';
import { createInstance, MatomoProvider } from '@jonkoops/matomo-tracker-react';
import UmamiAnalytics from '@danielgtmn/umami-react';

import {
  FeatureFlags,
  matomoDisabled,
  matomoProjectId,
  matomoUrl,
} from './application/constants/env-variables.ts';
import { GlobalErrorBoundary } from 'pages/GlobalErrorBoundary.tsx';

//to send dates to backend in local timezone (not in UTC)
Date.prototype.toISOString = function () {
  const result = formatISO(this);
  return result;
};

countries.registerLocale(en);
countries.registerLocale(de);
countries.registerLocale(es);
countries.registerLocale(fr);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const instance = createInstance({
  urlBase: matomoUrl(),
  siteId: matomoProjectId(),
  disabled: matomoDisabled(),
  heartBeat: {
    active: true,
    seconds: 15,
  },
  linkTracking: true,
  configurations: {
    disableCookies: true,
    setSecureCookie: true,
    setRequestMethod: 'POST',
  },
});

root.render(
  <React.StrictMode>
    <UmamiAnalytics
      url={FeatureFlags.umamiUrl()}
      websiteId={FeatureFlags.umamiSiteId()}
      onlyInProduction={false}
    />
    <GlobalErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <OpenIdCallback
          signInRedirectHandler={(user) => {
            if (!UseCookieAuth)
              setAuthData({
                access_token: user.access_token,
                refresh_token: user.refresh_token!,
              });
            window.history.pushState(null, '', backendUri);
          }}
          signOutRedirectHandler={() => {
            postServerLogOut();
          }}
          loading={<Loading loading={true} />}
          error={LoginErrorPage}
        >
          <MatomoProvider value={instance}>
            <App />
          </MatomoProvider>
        </OpenIdCallback>
      </QueryClientProvider>
    </GlobalErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
